import { Container } from "@mui/material";
import React from "react";
import { P, SectionWrapper } from "../../Styles/style";
import Twitter from "../../../assets/images/twitterfooter.png"
import Telegram from "../../../assets/images/telegramfooter.png"
import Medium from "../../../assets/images/mediumfooter.png"
import FooterPara from "../../Components/LockerMenu/component/FooterPara";
import { WrAPPER, SocialHeading, SocialMedia, SocialLinks, SocialImage, ParaDesktop, MobPara, } from "./styles";

const Section6_Footer = () => {
  return (
    <SectionWrapper p799="0px" p599="0px" p="6rem 0 0 0">
      <Container maxWidth="xl" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0">
        <WrAPPER>
          <ParaDesktop><FooterPara /></ParaDesktop>
          <SocialMedia>
            {/* <SocialHeading>Follow us</SocialHeading> */}
            <SocialLinks href="#" target="blank"><SocialImage src={Medium} /></SocialLinks>
            <SocialLinks href="#" target="blank"><SocialImage src={Telegram} /></SocialLinks>
            <SocialLinks href="#" target="blank"><SocialImage src={Twitter} /></SocialLinks>
          </SocialMedia>
          <MobPara><FooterPara /></MobPara>
        </WrAPPER>
      </Container>
    </SectionWrapper>
  )
};

export default Section6_Footer;
